import React from "react";
import Input from "../Builder/nodes/Logic/Inputs/Input";
import contactUUID from "./contactUUID";
import JsonCollapse from "../Builder/Components/JsonCollapse";

const inputFields = (cf) => [
  {
    inputField: "label",
    cols: 2,
    props: {
      label: "Label",
      isMulti: false,
      options: [],
      type: "",
    },
  },

  {
    inputField: "isPrimary",
    cols: 1,
    props: {
      label: "Primary",
      inputType: "checkbox",
      isDisabled: cf.isMultiple || cf.isSelect || cf.isUnique || cf.isDateTime,
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      type: "",
    },
  },

  {
    inputField: "isUnique",
    props: {
      label: "Unique",
      inputType: "checkbox",
      isMulti: false,
      isDisabled:
        cf.isPrimary ||
        cf.isMultiple ||
        cf.isSelect ||
        cf.isPrimary ||
        cf.isDateTime,
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      type: "",
    },
  },

  {
    inputField: "isCard",
    props: {
      label: "Show in card",
      inputType: "checkbox",
      isMulti: false,
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      type: "",
    },
  },

  {
    inputField: "isSms",
    props: {
      label: "SMS compatible",
      isDisabled: cf.isEmail || cf.isSelect || cf.isMultiple || cf.isDateTime,
      inputType: "checkbox",
      isValidNewOption: () => false,
      isMulti: false,
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      type: "",
    },
  },
  {
    inputField: "isEmail",
    props: {
      label: "Email compatible",
      isDisabled:
        cf.isSms || cf.isVoice || cf.isSelect || cf.isMultiple || cf.isDateTime,
      inputType: "checkbox",
      isMulti: false,
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      type: "",
    },
  },
  {
    inputField: "isVoice",
    props: {
      label: "Voice compatible",
      isDisabled: cf.isEmail || cf.isSelect || cf.isMultiple || cf.isDateTime,
      inputType: "checkbox",
      isMulti: false,
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      type: "",
    },
  },

  {
    inputField: "isDateTime",
    props: {
      label: "Date/time",
      isDisabled: cf.isPrimary || cf.isEmail || cf.isSelect,
      inputType: "checkbox",
      isMulti: false,
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      type: "",
    },
  },

  {
    inputField: "isSelect",
    props: {
      label: "Selectable",
      inputType: "checkbox",
      isMulti: false,
      isDisabled:
        !cf.isNew ||
        cf.isPrimary ||
        cf.isUnique ||
        cf.isSms ||
        cf.isVoice ||
        cf.isEmail ||
        cf.isDateTime,
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      type: "",
    },
  },

  {
    inputField: "isMultiple",
    props: {
      label: "Multiple allowed",
      isDisabled:
        cf.isPrimary || cf.isUnique || cf.isSms || cf.isVoice || cf.isEmail,
      inputType: "checkbox",
      isMulti: false,
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      type: "",
    },
  },

  ...(cf.isMultiple
    ? []
    : [
        {
          inputField: "minItemsRequired",
          props: {
            label: "Required?",
            isDisabled: cf.isUnique,
            inputType: "checkbox",
            isMulti: false,
            options: [
              { value: 1, label: "Yes" },
              { value: 0, label: "No" },
            ],
            type: "",
          },
        },
      ]),

  {
    inputField: "isHidden",
    props: {
      label: "Sensitive content",
      inputType: "checkbox",
      isMulti: false,
      options: [
        { value: true, label: "Yes" },
        { value: false, label: "No" },
      ],
      type: "",
    },
  },

  ...(cf.isMultiple || cf.isSelect || cf.isDateTime
    ? [
        {
          line: true,
        },
      ]
    : []),

  ...(cf.isMultiple
    ? [
        {
          inputField: "minItemsRequired",
          props: {
            label: "Minimum items required",
            isDisabled: cf.isUnique,
            isMulti: false,
            options: [],
            type: "number",
          },
        },
      ]
    : []),

  ...(cf.isSelect
    ? [
        {
          inputField: "selectType",
          props: {
            label: "Select type",
            inputType: "select",
            options: [
              { value: "time-zone", label: "Time zone" },
              { value: "country", label: "Country" },
              { value: "", label: "User defined options" },
            ],
          },
        },
        ...(!cf.selectType
          ? [
              {
                inputField: "options",
                props: {
                  label: "Selectable options",
                  isMulti: true,
                  isValidNewOption: (v) => !!v,
                  options: [],
                  type: "",
                },
              },
            ]
          : []),
      ]
    : []),

  ...(cf.isDateTime
    ? [
        {
          inputField: "dateTimeType",
          props: {
            label: "Date/time type",
            isDisabled: cf.isEmail || cf.isSelect,
            inputType: "select",
            isMulti: false,
            options: [
              { value: "dateTime", label: "Date and time" },
              { value: "date", label: "Date" },
              { value: "time", label: "Time" },
            ],
            type: "",
          },
        },
      ]
    : []),
];

export default function ContactFieldEditor({
  value,
  onChange,
  labelIsNotEditable = false,
}) {
  const handleChange = (inputField, values) => {
    onChange({
      ...value,
      [inputField]:
        inputField === "options"
          ? (values || []).map((fieldValue, i) => {
              const opt = value.options?.find((o) => o.label === fieldValue);
              return {
                uuid: opt?.uuid || contactUUID(),
                label: fieldValue,
                order: i,
              };
            })
          : values?.[0],
      ...(inputField === "isSelect" && values?.[0] === true
        ? {
            selectType: "",
          }
        : {}),
      ...(inputField === "isMultiple" && values?.[0] === false
        ? {
            minItemsRequired: 0,
          }
        : {}),
    });
  };

  return (
    <>
      <div className="mb-3">
        <Input
          value={[value.label]}
          onChange={(values) => handleChange("label", values)}
          label="Label"
          isDisabled={labelIsNotEditable}
        />
      </div>
      <div className="row align-items-end g-3">
        {inputFields(value)
          .slice(1)
          .map((input) =>
            input.line ? (
              <div key={`line-${value.uuid}`} className="col-12">
                <hr />
              </div>
            ) : (
              <div key={input.inputField} className="col-auto">
                <Input
                  value={
                    input.inputField === "options"
                      ? (Array.isArray(value[input.inputField])
                          ? value[input.inputField]
                          : []
                        ).map((opt) => opt.label)
                      : [
                          input.inputField === "selectType" &&
                          !value[input.inputField]
                            ? value[input.inputField] || ""
                            : value[input.inputField],
                        ]
                  }
                  onChange={(values) => handleChange(input.inputField, values)}
                  {...input.props}
                />
              </div>
            )
          )}
      </div>
      <JsonCollapse json={value} />
    </>
  );
}
